<template>
  <div>
    <!-- <Header title="审核提交"></Header> -->
    <div class="sub_succeed">
      <div class="call">{{ type == 0 ? "打卡" : "更新打卡" }}成功</div>
      <p>
        {{ type == 0 ? "打卡" : "更新打卡" }}时间为<br />
        <span>{{ time }}</span>
        <br />
        {{ type == 0 ? "打卡" : "更新打卡" }}地点为<br />
        <span>{{ addr }}</span>
      </p>
      <div class="icon_succeed"></div>
    </div>
    <div class="sub_succeed_foot">
      <button class="back_btn" @click="back()">知道了</button>
    </div>
    <div class="tips">点击“知道了”返回</div>
  </div>
</template>

<script>
export default {
  data() {
    return { type: "", addr: "", time: "" };
  },
  created() {
    console.log(this.$route.query);
    this.type = this.$route.query.type;
    this.addr = this.$route.query.list.dd;
    this.time = this.$route.query.list.sj;
  },
  methods: {
    back() {
      this.$router.push({
        path: "/sxKq/KQ",
        query: {
          list: this.$route.query.params
        }
      });
    }
  }
};
</script>

<style lang="less">
.sub_succeed {
  padding: 10px 40px;
  box-sizing: border-box;
  .call {
    color: #757da3;
    font-size: 24px;
    line-height: 35px;
    margin-bottom: 10px;
  }
  p {
    color: #757da3;
    font-size: 16px;
    line-height: 22px;
    white-space: nowrap;
    span {
      color: #757da3;
      font-size: 18px;
      font-weight: bold;
      white-space: pre-wrap;
      display: block;
    }
  }
}
.sub_succeed .icon_succeed {
  width: 120px;
  height: 120px;
  background: url(../../../../../static/img/succeed.png) no-repeat center center;
  background-size: contain;
  margin: 60px auto;
}
.back_btn {
  width: 100%;
  height: 44px;
  background: rgba(116, 105, 248, 1);
  border-radius: 3px;
  color: @attendance-color-3;
  font-size: 16px;
}
.sub_succeed_foot {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  position: fixed;
  bottom: 20px;
}
.tips {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: @attendance-color-2;
  margin-top: -55px;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxKq/time.vue